import { render, staticRenderFns } from "./IDVerifForm.vue?vue&type=template&id=70e994ab&scoped=true&"
import script from "./IDVerifForm.vue?vue&type=script&lang=js&"
export * from "./IDVerifForm.vue?vue&type=script&lang=js&"
import style0 from "./IDVerifForm.vue?vue&type=style&index=0&id=70e994ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e994ab",
  null
  
)

export default component.exports